import React from 'react';

import { ScreenFilters, ScreenFiltersApply } from 'components/Filters';
import { ScreenPresets } from 'components/Presets';
import isEmpty from 'lodash/isEmpty';

import {
  Screen,
  createScreenRoute,
  withScreen,
  useScreenState,
} from '@gogame/screens';

import PrimaryFilters from './components/Filters/PrimaryFilters';
import HomeDashboardUserStorage from './components/HomeDashboardUserStorage';
import HomeDashboardWelcome from './components/HomeDashboardWelcome';
import HomeDashboardWidgets from './components/HomeDashboardWidgets';
import { SCREEN_NAME } from './constants';
import {
  homeDashboardSearchParams,
  homeDashboardScreenLink,
} from './navigation';
import { mapStateToPreset, EMPTY_FILTERS } from './schemas';
import screenReducer from './screenReducer';

const id = 901;

const HomeDashboard = withScreen({
  name: SCREEN_NAME,
  reducer: screenReducer,
  searchParams: homeDashboardSearchParams,
})(() => {
  const screenState = useScreenState();

  return (
    <React.Fragment>
      <Screen.Toolbar />
      <Screen.Body>
        <ScreenPresets
          mapStateToPreset={mapStateToPreset}
          labelEmptyList={'No dashboards'}
          title={'Dashboard'}
          titleDialogAdd={'Add dashboard'}
          titleDialogUpdate={'Update dashboard'}
        />

        <ScreenFilters emptyValues={EMPTY_FILTERS}>
          <PrimaryFilters />
          <ScreenFiltersApply />
        </ScreenFilters>

        {isEmpty(screenState.filters.presets) ? (
          <HomeDashboardWelcome />
        ) : (
          <HomeDashboardWidgets />
        )}
      </Screen.Body>
    </React.Fragment>
  );
});

export default createScreenRoute({
  title: 'Home Dashboard',
  link: homeDashboardScreenLink,
  screen: <HomeDashboard />,
  id: id,
  storage: HomeDashboardUserStorage,
  knowledgeBaseUrl:
    'https://go-game.zendesk.com/hc/en-us/articles/360017236620-Home-Dashboard',
});
